<template>
  <div v-if="client_request_info" class="client_request_info">
    <div class="client_request_info__left">
      <div class="client_request_info__left__wrap" ref="content">
        <div class="main_info" ref="main_info">
          <div class="line row">
            <div class="col-md-1 col-sm-1">
              <fg-input v-model="client_request_info.id" type="text" :label="translate('client_request.id')"
                        :placeholder="translate('client_request.id')" :readonly="true" />
            </div>

            <div class="col-md-2 col-sm-2">
              <fg-input v-model="client_request_info.date" type="text" :label="translate('client_request.date')"
                        :placeholder="translate('client_request.date')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <label> {{ translate('client_request.type') }} </label>
              <tree-select v-model="client_request_info.type" :options="type_list"
                           :placeholder="translate('client_request.type')" disabled="disabled" :clearable="false" :searchable="false" />
            </div>

            <div class="col-md-3 col-sm-3">
              <label> {{ translate('client_request.status') }} </label>
              <tree-select v-model="client_request_info.status" :options="status_list"
                           :placeholder="translate('client_request.status')" disabled="disabled" :clearable="false" :searchable="false" />
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="client_request_info.service_id" type="text" :label="client_request_info.service_name"
                        :placeholder="client_request_info.service_name" :readonly="$store.getters.getPermissions.permissionGod !== true || client_request_info.status === 2" />
            </div>
          </div>

          <div class="line row">
            <div class="col-md-5 col-sm-5">
              <router-link :to="'/device/' + client_request_info.device.fid" class="link">
                <fg-input v-model="device_name" type="text" :label="translate('client_request.device')"
                          :placeholder="translate('client_request.device')" :readonly="true"/>
              </router-link>
            </div>

            <div class="col-md-4 col-sm-4">
              <router-link :to="'/device_list?&group=' + client_request_info.device.group_id" class="link">
                <fg-input v-model="client_request_info.device.group_name" type="text" :label="translate('client_request.group_name')"
                          :placeholder="translate('client_request.group_name')" :readonly="true"/>
              </router-link>
            </div>

            <div class="col-md-3 col-sm-3">
              <router-link :to="'/client/' + client_request_info.client_id" class="link">
                <fg-input v-model="client_request_info.client_name" type="text" :label="translate('client_request.client_name')"
                          :placeholder="translate('client_request.client_name')" :readonly="true" />
              </router-link>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-2 col-sm-2" v-if="client_request_info.type === 1">
              <fg-input
                  v-model="client_request_info.simcard_count"
                  type="number"
                  :label="translate('client_request.working_simcard_count')"
                  :placeholder="translate('client_request.working_simcard_count')"
                  :readonly="!$store.getters.getPermissions.permissionGod === true || client_request_info.status === 2"
              />
            </div>

            <div class="col-md-2 col-sm-2" v-if="client_request_info.bandwidth > 0">
              <fg-input v-model="client_request_info.bandwidth" type="text" :label="translate('client_request.bandwidth')"
                        :placeholder="translate('client_request.bandwidth')" :readonly="true" />
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="client_request_info.user_name" type="text" :label="translate('client_request.user_who_created_request')"
                        :placeholder="translate('client_request.user_who_created_request')" :readonly="true"/>
            </div>
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="date_created" type="text" :label="translate('client_request.created')"
                        :placeholder="translate('client_request.created')" :readonly="true" />
            </div>
            <div class="col-md-2 col-sm-2" v-if="$store.getters.getPermissions.permissionGod === true">
              <fg-input v-model="date_completed" type="text" :label="translate('client_request.completed')"
                        :placeholder="translate('client_request.completed')" :readonly="true" />
            </div>
          </div>

          <div class="line row" v-if="$store.getters.getPermissions.permissionGod === true && client_request_info.sim_task">
            <div class="col-md-4 col-sm-4">
              <router-link :to="'/sim_task/' + client_request_info.sim_task.id" class="link">
                <fg-input
                    :value="client_request_info.sim_task.description"
                    type="text"
                    :label="translate('sim_task.one')"
                    :readonly="true"
                />
              </router-link>
            </div>
          </div>

          <div class="line row" v-if="client_request_info.notification_emails">
            <div class="col-md-6 col-sm-6">
              <fg-input v-model="client_request_info.notification_emails" type="text" :label="translate('client_request.email_notification')"
                        :placeholder="translate('client_request.email_notification')" :readonly="true" />
            </div>
            <div class="col-md-4 col-sm-4">
              <fg-input
                  v-if="!notify_date.hide"
                  v-model="notify_date.text"
                  type="text"
                  :label="translate('client_request.sending_notify')"
                  :placeholder="translate('client_request.sending_notify')"
                  :readonly="true"
              />
            </div>
          </div>

          <div class="line row" v-if="client_request_info.comment">
            <div class="col-md-12 col-sm-12 text_wrap">
              <div class="form-group">
                <label>{{ translate('client_request.comment_from_user_who_created_request') }}</label>
                <textarea class="input_text" name="comment" v-model="client_request_info.comment" rows="5" :readonly="true"/>
              </div>
            </div>
          </div>
        </div>

        <div class="line text-center buttons" v-if="$store.getters.getPermissions.permissionGod === true">

          <span v-if="has_changes" class="btn btn-success btn-fill btn-wd" @click.prevent="edit_client_request()">
            {{ translate('btn.edit') }}
          </span>

          <div v-else class="other_buttons">
            <span
                v-if="client_request_info.status === 0"
                class="btn btn-success btn-fill btn-wd"
                @click.prevent="edit_status_client_request(1)"
            >
              {{ translate('client_request.take_on_work') }}
            </span>

            <span
                v-if="client_request_info.status === 1"
                class="btn btn-success btn-fill btn-wd"
                @click.prevent="edit_status_client_request(2)"
            >
              {{ translate('client_request.complete_success') }}
            </span>

              <span
                  v-if="client_request_info.status === 1"
                  class="btn btn-success btn-fill btn-wd"
                  @click.prevent="edit_status_client_request(4)"
              >
              {{ translate('client_request.close_with_error') }}
            </span>
          </div>

        </div>

        <div class="response_table" v-if="simcards.length > 0">
          <div class="header">
            <label v-if="client_request_info.type === 1">
              {{ translate('client_request.simcard_list_on_activation') }}
            </label>
            <label v-else>
              {{ translate('client_request.simcard_list_to_block') }}
            </label>

            <button v-if="simcards.length > 0" class="btn-info btn-fill btn-wd" @click="copy_iccid">
              {{ translate('client_request.copy_iccid') }}
            </button>
          </div>

          <table>
            <thead style="height: 50px; flex:0; display: inline-block">
              <tr>
                <th class="w30" scope="col">
                  {{ translate('client_request.simcard_list.slot') }}
                </th>
                <th class="status" scope="col" v-if="$store.getters.getPermissions.permissionGod === true">
                  {{ translate('client_request.simcard_list.status') }}
                </th>
                <th scope="col" v-if="$store.getters.getPermissions.permissionGod === true">
                  {{ translate('client_request.simcard_list.traffic') }}
                </th>
                <th scope="col">
                  {{ translate('client_request.simcard_list.oper_name') }}
                </th>
                <th scope="col" v-if="$store.getters.getPermissions.permissionGod === true">
                  {{ translate('client_request.simcard_list.imsi') }}
                </th>
                <th scope="col">
                  {{ translate('client_request.simcard_list.iccid') }}
                </th>
                <th scope="col">
                  {{ translate('client_request.simcard_list.status_profile') }}
                </th>
                <th scope="col">
                  {{ translate('client_request.simcard_list.ts_update') }}
                </th>
                <th
                    scope="col"
                    class="remove"
                    v-if="$store.getters.getPermissions.permissionGod === true && client_request_info.status < 2"
                >
                </th>
              </tr>
            </thead>
            <tbody>
              <router-link
                  v-for="(simcard, key) in simcards"
                  :key="key"
                  class="simcard_item"
                  :to="'/simcard_profile/' + simcard.simcard_profile_id + '/profile'"
                  :disabled="!simcard.simcard_profile_id !== null"
                  :event="simcard.simcard_profile_id !== null ? 'click' : ''"
              >
                <tr>
                  <td :data-label="translate('client_request.simcard_list.slot')" class="w30">
                    {{ simcard.slot }}
                  </td>
                  <td
                    v-if="$store.getters.getPermissions.permissionGod === true"
                    :data-label="translate('client_request.simcard_list.status')" class="status"
                  >
                    <SimState :sim_state="simcard.sim_state" />
                  </td>
                  <td
                    v-if="$store.getters.getPermissions.permissionGod === true"
                    :data-label="translate('client_request.simcard_list.traffic')"
                  >
                    {{ simcard.sim_state?.traffic ? simcard.sim_state.traffic : ""}}
                  </td>
                  <td :data-label="translate('client_request.simcard_list.oper_name')" @click.stop="">
                    <a
                        v-if="simcard.mno_link && $store.getters.getPermissions.permissionGod === true"
                        :href="simcard.mno_link"
                        target="_blank"
                        class="pointer"
                    >
                      {{ simcard.oper_name }}
                    </a>
                    <template v-else>
                      {{ simcard.oper_name }}
                    </template>
                  </td>
                  <td
                    v-if="$store.getters.getPermissions.permissionGod === true"
                    :data-label="translate('client_request.simcard_list.imsi')"
                  >
                    {{ simcard.imsi }}
                  </td>
                  <td :data-label="translate('client_request.simcard_list.iccid')" @click.prevent.stop="" class="text-left">
                    <router-link  :to="'/simcard_devices_list?&msisdn_imsi_iccid=' + simcard.iccid" @click.prevent.stop="">
                      {{ simcard.iccid }}
                    </router-link>
                    <i class="copy mdi mdi-content-copy" @click.prevent.stop="copy_text(simcard.iccid)"/>
                  </td>
                  <td :data-label="translate('client_request.simcard_list.status_profile')" >
                    <span class="badge" :class="global_status_color(+simcard.status)">
                      {{ translate(global_status_text(+simcard.status)) }}
                    </span>
                  </td>
                  <td :data-label="translate('client_request.simcard_list.ts_update')">
                    {{ get_date(simcard.ts_update) }}
                  </td>
                  <td
                      :data-label="translate('client_request.simcard_list.ts_update')"
                      class="remove"
                      v-if="$store.getters.getPermissions.permissionGod === true && client_request_info.status < 2"
                  >
                    <span class="mdi mdi-check" @click.prevent="update_simcard_status(simcard)" />
                    <span class="mdi mdi-close" @click.prevent="remove_simcard(simcard)" />
                  </td>
                </tr>
              </router-link>
            </tbody>
          </table>
        </div>

        <div class="new_simcard__block" v-if="$store.getters.getPermissions.permissionGod === true && client_request_info.status < 2">
          <div class="new_simcard" @click="add_simcard()">
            <span class="mdi mdi-plus-box" />
            <span class="title">
              {{ translate("client_request.simcard_list.add_simcard") }}
            </span>
          </div>
        </div>


        <div class="response_table" v-if="$store.getters.getPermissions.permissionGod === true && client_request_info.prev_requests.length > 0">
          <div class="header">
            <label>
              {{ translate('client_request.previous_requests') }}
            </label>
          </div>

          <table>
            <thead style="height: 50px; flex:0; display: inline-block">
            <tr>
              <th scope="col">
                {{ translate('client_request.date') }}
              </th>
              <th scope="col">
                {{ translate('client_request.type') }}
              </th>
              <th scope="col">
                {{ translate('client_request.status') }}
              </th>
              <th scope="col">
                {{ translate('client_request.working_simcard_count') }}
              </th>
              <th scope="col">
                {{ client_request_info.service_name }}
              </th>
              <th scope="col">
                {{ translate('client_request.client_name') }}
              </th>
            </tr>
            </thead>
            <tbody>
              <router-link
                 v-for="(request, key) in client_request_info.prev_requests"
                 :key="key"
                 class="request_item"
                 :to="'/client_request/' + request.id + '/info'">
                <tr>
                  <td :data-label="translate('client_request.date')">
                    {{ request.date }}
                  </td>
                  <td :data-label="translate('client_request.type')" class="limit">
                    <span class="badge" :style="'background-color: ' + new_type(request.type).color">
                      {{ new_type(request.type).title }}
                    </span>
                  </td>
                  <td :data-label="translate('client_request.status')" class="limit">
                    <span class="badge" :style="'background-color: ' + new_status(request.status).color">
                      {{ new_status(request.status).title }}
                    </span>
                  </td>
                  <td :data-label="translate('client_request.working_simcard_count')">
                    {{ request.simcard_count }}
                  </td>
                  <td :data-label="client_request_info.service_name">
                    {{ request.service_id }}
                  </td>
                  <td :data-label="translate('client_request.client_name')" >
                    <router-link :to="{path: '/client/' + request.client_id}">
                      {{ request.client_name }}
                    </router-link>
                  </td>
                </tr>

              </router-link>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <div class="client_request_info__right">
      <Summary type="client_request" :info="client_request_info" :view_history="false" />
    </div>
  </div>

</template>
<script>
import Summary from "components/UIComponents/Summary/Summary.vue";
import AddSimcard from "./Modal/AddSimcard.vue";
import SimState from "components/UIComponents/SimState/Index.vue";

const fields_to_check = ["service_id", "simcard_count"];

export default {
  name: 'ClientRequestInfo',
  components: {
    SimState,
    Summary
  },

  props: {
    client_request: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      client_request_info: {},
      filter_asc: "asc",
      filter_type: ""
    }
  },

  created() {
    this.client_request_info = JSON.parse(JSON.stringify(this.client_request))
  },

  activated() {
    this.client_request_info = JSON.parse(JSON.stringify(this.client_request))
  },

  computed: {
    notify_date(){
      let text = ""
      if (this.client_request_info.notify_on_modem_online === 1) {
        text = this.translate("client_request.notify_be_sent")
      } else if (this.client_request_info.notify_on_modem_online === 0 && this.client_request_info.modem_online_notified_at !== null){
        text = this.translate("client_request.notify_sent", {datetime: this.get_date(this.client_request_info.modem_online_notified_at)})
      }

      return {
        text: text,
        hide: this.client_request_info.notify_on_modem_online === 0 && this.client_request_info.modem_online_notified_at === null
      }
    },
    device_name(){
      return this.client_request_info.device.fid + " / " + this.client_request_info.device.name
    },
    date_completed(){
      return this.get_date(this.client_request_info.complete_ts)
    },
    date_created(){
      return this.get_date(this.client_request_info.create_ts)
    },
    simcards() {
      return this.client_request.simcards;
    },
    type_list(){
      return this.$store.getters.getClientRequestsInfo.types.map((entry) => {
        return { id: entry.id, label: this.translate("client_request.types." + entry.title) }
      })
    },
    status_list() {
      return this.$store.getters.getClientRequestsInfo.statuses.map((entry) => {
        return { id: entry.id, label: this.translate("client_request.statuses." + entry.title) }
      })
    },
    has_changes() {
      let main_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.client_request[key];
        return obj;
      }, {});

      let client_request_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.client_request_info[key];
        return obj;
      }, {});

      return JSON.stringify(main_info) !== JSON.stringify(client_request_info);
    }
  },

  watch: {
    client_request(){
      this.client_request_info = {...this.client_request}
    }
  },

  methods: {
    new_status(status){
      let result = this.$store.getters.getClientRequestsInfo.statuses.find((entry) => {
        if (entry.id === status){
          return entry
        }
      })
      return result ? {...result, title: this.translate("client_request.statuses." + result.title) } : {title: "Error", color: "red"}
    },
    new_type(type){
      let result = this.$store.getters.getClientRequestsInfo.types.find((entry) => {
        if (entry.id === type){
          return entry
        }
      })
      return result ? {...result, title: this.translate("client_request.types." + result.title) } : {title: "Error", color: "red"}
    },
    copy_iccid(){
      let string = ""
      this.simcards.forEach((item, key) => {
        string += `${item.oper_name}\t`
        string += `${item.iccid}\t`

        if (key !== this.simcards.length - 1){
          string += `\r`
        }
      })
      this.copy_to_clipboard(string);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    copy_text(text){
      this.copy_to_clipboard(text);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    update_simcard_status(simcard){
      this.$http.v1.updateSimcardStatusClientRequest(this.client_request_info.id, {simcard_id: simcard.id}, (response) => {
        this.global_notify('info', this.translate('client_request.saved_success'))
        this.client_request_info = response.data
        this.$emit('update')
      })
    },
    remove_simcard(simcard){
      this.$http.v1.removeSimcardClientRequest(this.client_request_info.id, {simcard_id: simcard.id}, (response) => {
        this.global_notify('info', this.translate('client_request.saved_success'))
        this.client_request_info = response.data
        this.$emit('update')
      })
    },
    add_simcard() {
      let t = this.$createElement(AddSimcard, {
        props: {
          client_request_id: this.client_request_info.id
        },
        on: {
          close: () => {
            this.$modal.hide('client_order_modal')
          },
          update: () => {
            this.$emit('update')
            this.$modal.hide('client_order_modal')
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'client_order_modal'
      })
    },
    edit_client_request() {
      const params = {
        service_id: this.client_request_info.service_id,
        simcard_count: Number(this.client_request_info.simcard_count)
      }

      this.$http.v1.updateClientRequest(this.client_request_info.id, params, (response) => {
        this.global_notify('info', this.translate('client_request.saved_success'))
        this.client_request_info = response.data
        this.$emit('update')
      })
    },
    edit_status_client_request(status) {
      this.$http.v1.updateStatusClientRequest(this.client_request_info.id, {status}, (response) => {
        this.global_notify('info', this.translate('client_request.saved_success'))
        this.client_request_info = response.data
        this.$emit('update')
      })
    },
  }
}

</script>

<style lang='scss' scoped>
.client_request_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    .form_select{
      .form-control {
        width: 100%;
      }
    }

    .response_table {
      height: auto;
      padding: 0;
      margin-top: 10px;

      .header{
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 5px;
      }

      .status {
        width: 5%;
      }

      table {
        tbody {
          .online {
            color: #15ab00;
          }

          span.badge {
            font-size: 12px;
          }

          span {
            font-size: 20px;
          }
          .simcard_item,
          .request_item{
            color: #66615b;
            &:hover{
              tr{
                background-color: #eee;
              }
            }
            td{
              p{
                margin-bottom: 0;
                font-size: 10px;
              }
            }
            a.pointer{
              position: relative;
              &::before {
                position: absolute;
                display: block;
                bottom: 2px;
                right: -15px;
                width: 12px;
                height: 12px;
                content: "🔗";
                font-size: 12px;
              }
            }
            .copy{
              width: 10px;
              height: 10px;
            }
            .text-left{
              text-align: left;
            }
          }
        }

        td {
          padding: 5px;
        }
        .remove{
          width: 60px;
          .mdi{
            vertical-align: middle;

          }
          .mdi-check{
            &:hover{
              color: darkgreen;
            }
          }
          .mdi-close{
            &:hover{
              color: darkred;
            }
          }

        }
      }
      .w70{
        width: 70px;
      }
      .w30{
        width: 30px;
      }
    }

    .new_simcard {
      cursor: pointer;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 10px;
      padding: 10px;
      background: #41b8831f;
      border: 1px dashed #41b883;
      transition: 0.2s;
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
      .mdi {
        font-size: 20px;
      }
      span{
        font-size: 14px;
      }
      &__block{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
      }
      &:hover {
        background: #41b8835e;
      }
    }

    .buttons {
      margin: 10px 0;
      .btn{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
